export const environment = {
  production: false,
  apiUrl: 'https://flipeon-release.jnmoura.com.br/api',
  BPM_IMG_URL: 'https://bancoprodutomoura-dev.s3.us-west-002.backblazeb2.com/img'
};